import { ButtonLink } from 'src/components/links';
import EditAmpSection from '../components/EditAmpSection';
import EditHtmlSection from '../components/EditHtmlSection';
import EditTextSection from '../components/EditTextSection';
import EditTestDataSection from '../components/EditTestDataSection';

const editTabs = [
  {
    content: 'HTML',
    key: 'html',
    render: EditHtmlSection,
    Component: ButtonLink,
    'data-id': 'tab-html'
  },
  {
    content: 'AMP HTML',
    key: 'amp_html',
    render: EditAmpSection,
    Component: ButtonLink,
    'data-id': 'tab-amp-html'
  },
  {
    content: 'Text',
    key: 'text',
    render: EditTextSection,
    Component: ButtonLink,
    'data-id': 'tab-text'
  },
  {
    content: 'Test Data',
    key: 'test_data',
    render: EditTestDataSection,
    Component: ButtonLink,
    'data-id': 'tab-test-data'
  }
];

export default editTabs;
